export const getFullAPIUrl = (baseUrl, mode, token=null) => {
    let param = ""
    if (mode === "files"){
         param = "utilities/files"
    } else if (mode === "download"){
        param = "utilities/download"
    } else if (mode === "create"){
        param = "utilities/create"
    }

    if (mode === "create" || mode === "files" || mode === "files") {
        return baseUrl + param
    }

    return baseUrl + param + "/" + (token === null ? localStorage.getItem("token") : token) + "/"
}